import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useRolesContext } from "../../hooks/roles/useRolesContext";
import { ContentHeader, MainContentArea } from "melco-ui";
import { ManageThreadsList } from "../../components/threads/ManageThreadsList";
import { AddThreadActionButton } from "../../components/threads/AddThreadActionButton";
//import { AddThreadActionButton } from "../../components/threads/AddThreadActionButton";

export const ManageThreads: React.FC = () => {
    const { t } = useTranslation();
    const [isThreadDrawerOpen, setIsThreadDrawerOpen] = useState<boolean>(false);
    const [threadIdToUpdate] = useState<string>("");
    const { roles } = useRolesContext();

    // const setOpenThreadDrawerAndSettingValuesFunction = (drawerOpen: boolean, threadId: string) => {
    //   setOpenThreadDrawerFunction(drawerOpen);
    //   setThreadIdToUpdate(threadId);
    // }

    const setOpenThreadDrawerFunction = (drawerOpen: boolean) => {
        setIsThreadDrawerOpen(drawerOpen);
    }



    return (
        <MainContentArea
            header={
                <ContentHeader
                    title={t("managethreads.title")}
                    // title={t("manage")}
                    extra={

                        <>
                            {(roles.SYSTEM_THREADS_CREATE) && <AddThreadActionButton />
                            }
                            {/* {
            //    roles.SYSTEM_HOOPS_CREATE && <AddThreadsThreadButton
            //       setIsAddThreadsThreadDrawerOpenAction={setOpenThreadDrawerAndSettingValuesFunction}

            //     />
            //   }
            //   {
            //    roles.SYSTEM_HOOPS_CREATE && <AddThreadsThreadButton
            //       setIsAddThreadsThreadDrawerOpenAction={setOpenThreadDrawerAndSettingValuesFunction}
            //     />
            //   } */}

                        </>
                    }
                />

            }
        >

            <ManageThreadsList
                threadIdToUpdate={threadIdToUpdate}

                isThreadDrawerOpen={isThreadDrawerOpen}
                setThreadDrawerOpenFunction={setOpenThreadDrawerFunction} />
        </MainContentArea>
    );
};